<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      currentDay: new Date(),
      selectedDay: "",
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
      daysInMonth: null,
      //FF
      filter: {
        search: "",
      },
    };
  },
  computed: {
    ...mapState("CumpleanosModule", ["birthdaysDays", "birthdaysDates"]),
  },
  mounted() {
    this.daysInMonth = this.getDaysInMonth(
      this.selectedYear,
      this.selectedMonth
    );
    this.getBirthDays();
    this.getBirthDates();

    //FF
    this.selectedDay = this.currentDay.getDate();
  },
  methods: {
    ...mapActions("CumpleanosModule", ["getBirthDate", "getBirthDay"]),

    async getBirthDays() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        month: (this.selectedMonth + 1).toString(),
      };
      await this.getBirthDay(data_);
    },

    async getBirthDates() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        month: (this.selectedMonth + 1).toString(),
        day: this.selectedDay.toString(),
      };
      await this.getBirthDate(data_);
    },

    getMonth(date = new Date()) {
      return date.getMonth() + 1;
    },
    getYear(date = new Date()) {
      return date.getFullYear();
    },
    getDaysInMonth(year, month) {
      // console.log("segundo", year, month)
      const Calendar = require("calendar").Calendar;
      const cal = new Calendar(1);
      const m = cal.monthDays(year, parseInt(month));

      return m;
    },
    toDayNumber(date) {
      return date.toLocaleString("es-CL", { day: "numeric" });
    },
    toMonthName(monthNumber) {
      const newDate = new Date();
      newDate.setMonth(monthNumber - 1);

      return newDate.toLocaleString("es-CL", {
        month: "long",
      });
    },
    changeSelectedDay(day) {
      this.selectedDay = day;
    },
    toDateLegible(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);

      return newDate.toLocaleString("es-CL", {
        day: "numeric",
        month: "long",
      });
    },
    //FF
    next() {
      // console.log(this.selectedMonth)
      this.selectedMonth++;
    },
    prev() {
      this.selectedMonth--;
    },
  },
  watch: {
    "filter.year"(value) {
      this.daysInMonth = this.getDaysInMonth(
        parseInt(value.label),
        parseInt(this.selectedMonth)
      );
      this.getBirthDates();
      this.getBirthDays();
    },
    selectedMonth(newMonth) {
      if (newMonth >= 12) {
        this.selectedMonth = parseInt(0);
        this.selectedYear = this.selectedYear + 1;
        // console.log("NUEVO AÑO", this.selectedYear)
      }
      if (newMonth <= -1) {
        this.selectedMonth = parseInt(11);
        this.selectedYear = this.selectedYear - 1;
        // console.log("AÑO ANTERIOR", this.selectedYear)
      }
      this.daysInMonth = this.getDaysInMonth(
        parseInt(this.selectedYear),
        parseInt(this.selectedMonth)
      );
      this.getBirthDays();
      this.getBirthDates();
    },
    selectedDay: function () {
      this.getBirthDates();
    },
  },
};
</script>

<template>
  <section id="cumpleanos">
    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main">
          Cumpleaños
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home" class="color-main">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Volver al Home
              </router-link>
            </li>
            <!-- <li class="breadcrumb-item text-capitalize active">
                Cumpleaños
              </li> -->
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          Descubre quienes están de cumpleaños este mes y salúdalos en su día.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-3 input-display input-display-left mb-3 m-lg-0">
        <img
          width="70"
          height="70"
          class="img-object-cover rounded-circle"
          src="@/assets/img/intranet/cumpleanios/cumpleanios-cake.svg"
        />
      </div>
      <div
        class="col-12 col-lg-6 mb-3 mb-lg-0 d-flex align-items-center justify-content-between"
      >
        <a href="javascript:" @click="prev()" class="h3 mb-0 color-main">
          <font-awesome-icon icon="fa-solid fa-angle-left"></font-awesome-icon>
        </a>
        <h2 class="font-700 text-capitalize color-main">
          {{ toMonthName(selectedMonth + 1) }}
        </h2>
        <a href="javascript:" @click="next()" class="h3 mb-0 color-main">
          <font-awesome-icon icon="fa-solid fa-angle-right"></font-awesome-icon>
        </a>
      </div>
    </div>

    <div class="row cumpleanios">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-body">
            <h4 class="font-700 color-main text-center mb-4">
              ¡Recuerda saludar a tus compañeros!
            </h4>

            <div class="row w-80">
              <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                <div v-if="birthdaysDays" class="card border border-2">
                  <div class="card-body">
                    <h3 class="font-700 text-capitalize color-main text-center">
                      {{ toMonthName(selectedMonth + 1) }}
                      {{ selectedYear }}
                    </h3>

                    <div class="calendar-custom">
                      <div class="calendar-custom-week">
                        <div class="calendar-custom-week-day">L</div>
                        <div class="calendar-custom-week-day">M</div>
                        <div class="calendar-custom-week-day">X</div>
                        <div class="calendar-custom-week-day">J</div>
                        <div class="calendar-custom-week-day">V</div>
                        <div class="calendar-custom-week-day">S</div>
                        <div class="calendar-custom-week-day">D</div>
                      </div>
                      <div
                        v-for="(week, i) in daysInMonth"
                        :key="i"
                        class="calendar-custom-week"
                      >
                        <a
                          v-for="(day, k) in week"
                          :key="k"
                          href="javascript:"
                          @click="changeSelectedDay(day)"
                          class="calendar-custom-week-number"
                          :class="`
                              ${
                                birthdaysDays.some((e) => e['day'] == day)
                                  ? 'calendar-custom-week-number-birthday'
                                  : ''
                              }
                              ${
                                day === currentDay.getDate() &&
                                selectedMonth === currentDay.getMonth() &&
                                selectedYear === currentDay.getFullYear()
                                  ? 'calendar-custom-week-number-current'
                                  : ''
                              }
                              ${
                                day === selectedDay && day > 0
                                  ? 'calendar-custom-week-number-selected'
                                  : ''
                              }
                            }`"
                        >
                          {{ day !== 0 ? day : "" }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-2">
                  <p
                    class="text-secondary text-opacity-75 d-flex align-items-center mb-0"
                  >
                    <span class="circle-text border border-main me-1"></span>
                    Día actual
                  </p>
                  <p
                    class="text-secondary text-opacity-75 d-flex align-items-center mb-0"
                  >
                    <span class="circle-text bg-main me-1"></span> Día
                    seleccionado
                  </p>
                  <p
                    class="text-secondary text-opacity-75 d-flex align-items-center mb-0"
                  >
                    <span class="circle-text border bg-gray me-1"></span> Este día hay cumpleaños
                  </p>
                </div>
              </div>
              <div
                :class="
                  birthdaysDates.length > 0
                    ? 'col-12 col-lg-6 overflow-500 card border p-0 border-2'
                    : 'col-12 col-lg-6 p-0 overflow-500'
                "
              >
                <div
                  v-for="usuario in birthdaysDates"
                  :key="usuario.id_usuario"
                  class="d-flex align-items-start padding-2-4 border-bottom-1"
                >
                  <div class="flex-shrink-0">
                    <img
                      width="70"
                      height="70"
                      class="img-object-cover rounded-circle"
                      v-if="
                        usuario.imagen_perfil ||
                        /.jpg|.jpeg|.png/.test(usuario.imagen_perfil)
                      "
                      :src="usuario.imagen_perfil"
                    />
                    <img
                      v-else
                      width="70"
                      height="70"
                      class="img-object-cover rounded-circle"
                      src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                    />
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <p class="d-grid text-secondary mb-0">
                      <strong class="ellipsis-custom">
                        {{ capitalizeFirstLetter(usuario.primer_nombre) }}
                        {{ capitalizeFirstLetter(usuario.apellido_paterno) }}
                      </strong>
                      <span
                        class="text-secondary text-opacity-75 ellipsis-custom"
                      >
                        Cargo:
                        {{
                          capitalizeFirstLetter(usuario.cargo[0].nombre_cargo)
                        }}
                      </span>
                      <span class="color-main ellipsis-custom">
                        <strong>{{
                          toDateLegible(usuario.fecha_nacimiento)
                        }}</strong>
                      </span>
                    </p>
                  </div>
                  <!-- <div 
                      class="flex-shrink-0 d-flex align-items-center">
                      <a 
                        href="javascript:"
                        class="fs-4 color-main"
                        >
                        <font-awesome-icon icon="fa-solid fa-comment-dots"></font-awesome-icon>
                      </a>
                    </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
